var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contents" } }, [
    _c(
      "div",
      { staticClass: "contents_wrap" },
      [
        _c("h2", { staticClass: "pg_title" }, [
          _c("span", [_vm._v(_vm._s(_vm.pageTitle))])
        ]),
        _vm._v(" "),
        _vm.getCondition !== null
          ? _c("knowledge-search", {
              attrs: { boardId: _vm.getBoardId, condition: _vm.getCondition },
              on: { "current-page": _vm.setCurrentPage }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.isLoading
          ? _c("div")
          : _c("div", [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "resize",
                      rawName: "v-resize",
                      value: _vm.setGridResizeColumn,
                      expression: "setGridResizeColumn"
                    }
                  ],
                  staticClass: "grid_wrap"
                },
                [
                  _c("knowledge-list-grid", {
                    attrs: {
                      gridId: _vm.gridId,
                      data: _vm.gridData,
                      columns: _vm.columns,
                      options: _vm.options,
                      pageOptions: _vm.pageOptions,
                      click: _vm.contentClick,
                      isTotalCount: true
                    },
                    on: { "grid-total-count": _vm.setTotalCount }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "paginate" },
                [
                  _c("sdl-pagination", {
                    attrs: {
                      align: "center",
                      "current-page": _vm.currentPage,
                      "total-rows": _vm.totalCount,
                      "per-page": _vm.perPage
                    },
                    on: { change: _vm.movePage }
                  })
                ],
                1
              )
            ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-246f4c44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-246f4c44","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/gspnCon/SvcToolList.vue
// module id = UYAa
// module chunks = 0